import { formatPhoneNumber } from '@spike/phone-utils';
import { OrganizationMarketplace } from '@spike/marketplace-model';
import { TableCell } from 'components/UI/V3/Table/Cell/TableCell';
import { TableRow } from 'components/UI/V3/Table/Row/TableRow';
import { FunctionComponent } from 'react';

interface LocationsTableRowProps {
    location: OrganizationMarketplace;
    fallbackCountryId?: string;
}

const formatStreet = (location: OrganizationMarketplace) =>
    [location.address?.street, location.address?.suite].filter(Boolean).join(', ');

const formatCityState = (location: OrganizationMarketplace) => {
    const city = location.address?.city || location.city;
    const state = location.address?.state;
    return [city, state].filter(Boolean).join(', ');
};

const formatPhone = (phone: string, countryId?: string) => {
    if (!phone || !countryId) {
        return phone ?? '';
    }

    return formatPhoneNumber(phone, countryId);
};

export const LocationsTableRow: FunctionComponent<LocationsTableRowProps> = props => {
    const countryId = props.location.address?.country?.id || props.fallbackCountryId;

    return (
        <TableRow>
            <TableCell>{props.location.name}</TableCell>
            <TableCell>{formatStreet(props.location)}</TableCell>
            <TableCell>{formatCityState(props.location)}</TableCell>
            <TableCell>{formatPhone(props.location.phone, countryId)}</TableCell>
            <TableCell>{props.location.email}</TableCell>
        </TableRow>
    );
};

export default LocationsTableRow;
